import qs from 'qs';
export function DataFrames(client) {
    return {
        get(masterAccountId, uploadSetId, uploadFileId, dataFrameId) {
            return client.get(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/upload-files/${uploadFileId}/data-frames/${dataFrameId}`);
        },
        put(masterAccountId, uploadSetId, uploadFileId, dataFrameId, data) {
            return client.put(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/upload-files/${uploadFileId}/data-frames/${dataFrameId}`, data);
        },
        getData(masterAccountId, uploadSetId, uploadFileId, dataFrameId) {
            return client.get(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/upload-files/${uploadFileId}/data-frames/${dataFrameId}/data`);
        },
        delete(masterAccountId, uploadSetId, uploadFileId, dataFrameId) {
            return client.delete(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/upload-files/${uploadFileId}/data-frames/${dataFrameId}`);
        },
        applyResolutionMethod(masterAccountId, uploadSetId, uploadFileId, dataFrameId, resolverName, config) {
            return client.post(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/upload-files/${uploadFileId}/data-frames/${dataFrameId}/notification-resolution`, {
                resolutionMethod: 'applyResolver',
                resolverName
            }, config);
        },
        ignoreRecordsWithNotifications(masterAccountId, uploadSetId, uploadFileId, dataFrameId, notificationNames, config) {
            return client.post(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/upload-files/${uploadFileId}/data-frames/${dataFrameId}/notification-resolution`, {
                resolutionMethod: 'ignoreRecords',
                notificationTypes: notificationNames
            }, config);
        },
        getDataMergePreview(masterAccountId, uploadSetId, uploadFileId, dataFrameId, limit, offset) {
            return client.get(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/upload-files/${uploadFileId}/data-frames/${dataFrameId}/preview`, { params: { limit, offset } });
        },
        getRecords(masterAccountId, uploadSetId, uploadFileId, dataFrameId, dataSource, limit, offset, metadataTypes, columnName, shouldValidate) {
            return client.get(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/upload-files/${uploadFileId}/data-frames/${dataFrameId}/content-records`, {
                params: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (limit !== undefined && { limit })), (offset !== undefined && { offset })), (columnName !== undefined && columnName !== null && { column_name: columnName })), (shouldValidate !== undefined && shouldValidate !== null && { should_validate: shouldValidate })), (metadataTypes !== undefined && { metadata_types: metadataTypes })), { data_source: dataSource }),
                paramsSerializer: (params) => {
                    return qs.stringify(params, { indices: false });
                }
            });
        }
    };
}
